import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Input } from "@/app/global-components/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/app/global-components/form";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useLocale } from "@/middleware";

interface RegisterFormFieldProps<T extends FieldValues> {
  name: FieldPath<T>;
  label: string;
  placeholder: string;
  description?: string;
  inputType?: string;
  formControl: Control<T>;
}

const RegisterFieldView = <T extends FieldValues>({
  name,
  label,
  placeholder,
  inputType,
  formControl,
}: RegisterFormFieldProps<T>) => {
  const { locale } = useLocale();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field }) => (
        <FormItem className="mb-4">
          <FormLabel className="mb-2 text-sm md:text-base">{label}</FormLabel>
          <FormControl>
            <div className="relative">
              <Input
                placeholder={placeholder}
                type={
                  inputType === "password" && showPassword
                    ? "text"
                    : inputType || "text"
                }
                {...field}
              />
              {inputType === "password" && (
                <button
                  type="button"
                  className={cn(
                    "absolute top-1/2 -translate-y-1/2",
                    locale === "en" ? "right-3" : "left-3"
                  )}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FaRegEye className="h-5 w-5 text-gray-500" />
                  ) : (
                    <FaRegEyeSlash className="h-5 w-5 text-gray-500" />
                  )}
                </button>
              )}
            </div>
          </FormControl>
          <FormMessage className="text-red-500 text-xs sm:text-sm" />
        </FormItem>
      )}
    />
  );
};

export default RegisterFieldView;
